import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Modal } from '../Modal/Modal';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  ticketId: string | null;
};

export const HelpdeskSuccessModal = ({ isVisible, onClose, ticketId }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isVisible} onClose={onClose}>
      <Box maxWidth={380}>
        <Typography variant="subtitle1" sx={{ fontWeight: '600' }}>
          {ticketId ? t('success.titleWithId', { ticketId }) : t('success.title')}
        </Typography>
        <Box mt={2}>
          <Typography variant="body1">{t('success.body')}</Typography>
        </Box>

        <Box mt={3} sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Button
            variant="contained"
            sx={{ textTransform: 'none', fontSize: '1rem' }}
            onClick={onClose}
          >
            {t('actions.ok')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
